import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [
      createPersistedState({ 
          key: "loginvuexdata",
          storage: window.sessionStorage
        })
    ],
  state: {
    loading: false,
    tai: '',
    locale: '',
    loginWords: {},
    mobileFormWords: {},
    credentialsFormWords: {},
    otpFromWords: {},
    silentRegistrationFormWords: {},
    msisdn: '',
    step1Visited: false,
    isSilentRegistration: false
  },
  mutations: {
    loading(state, data) {
        state.loading = data;
    },
    tai(state, data) {
        state.tai = data;
    },
    locale(state, data) {
        state.locale = data;
    },
    loginWords(state, data) {
        state.loginWords = data;
    },
    mobileFormWords(state, data) {
        state.mobileFormWords = data;
    },
    credentialsFormWords(state, data) {
        state.credentialsFormWords = data;
    },
    otpFromWords(state, data) {
        state.otpFromWords = data;
    },
    silentRegistrationFormWords(state, data) {
        state.silentRegistrationFormWords = data;
    },
    msisdn(state, data) {
        state.msisdn = data;
    },
    step1Visited(state, data) {
        state.step1Visited = data;
    },
    isSilentRegistration(state, data) {
        state.isSilentRegistration = data;
    }
  },
  actions: {
    resetState(context) {
        context.commit('msisdn', '');
        context.commit('step1Visited', false);
        context.commit('isSilentRegistration', false);
    }
  },
  modules: {
  },
  getters: {
      locale(state) {
          return state.locale;
      }
  }
})